import React, { useState } from 'react';

import InputCheckbox from '../InputCheckbox';
import { Row } from '../../Structure';
import useDeclarationData from '../../../hooks/useDeclarationData';

const SignatureCheckboxs = ({ onChange }) => {
  const [values, setValues] = useState(useDeclarationData());

  const updateChecked = (event) => {
    onChange({ name: event.name, value: event.checked });
    const { name, checked } = event;
    values[name] = checked;
    setValues({ ...values });
  };

  return (
    <>
      <Row>
        <InputCheckbox
          name="declaration"
          onChange={updateChecked}
          required
          checked={values.declaration}
        >
          By signing this section I certify that the details on this application
          are correct to the best of my knowledge for the applicant. I
          understand that the applicant named above may be contacted to confirm
          the details I have given.*
        </InputCheckbox>
      </Row>
      <Row>
        <InputCheckbox
          name="signedLogbook"
          onChange={updateChecked}
          required
          checked={values.signedLogbook}
        >
          By checking this box l also confirm that l will make my
          logbook/employee&apos;s logbook available for audit and understand that if
          l cannot produce the completed logbook, then my card application may
          be revoked*
        </InputCheckbox>
      </Row>
      <Row>
        <InputCheckbox
          name="terms"
          onChange={updateChecked}
          required
          checked={values.terms}
        >
          <span>I agree to the Terms </span>
          <a
            href="https://cpcs.nocn.org.uk/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy*
          </a>
        </InputCheckbox>
      </Row>
    </>
  );
};

export default SignatureCheckboxs;
